























import Vue from 'vue';
import {
  OpenMakePrimaryBankAccountScreen,
  OpenRemoveBankAccountScreen,
} from '@/mixins/get-content-mixins';
import { ExtendMixins } from '@/services';

export default ExtendMixins(
  OpenMakePrimaryBankAccountScreen,
  OpenRemoveBankAccountScreen,
).extend({
  name: 'BankAccount',
  props: {
    bankKey: {
      type: String,
      required: true,
    },
    bankName: {
      type: String,
      required: true,
    },
    accountType: {
      type: String,
      required: true,
    },
    accountNumber: {
      type: String,
      required: true,
    },
    routingNumber: {
      type: String,
      required: true,
    },
    isPrimaryAccount: {
      type: Boolean,
      default: false,
    },
    isSoleAccount: {
      default: false,
    },
  },
});
